export const Substack = () => (
  <svg height="100%" viewBox="0 0 23 26" width="100%">
    <path
      d="M22.8533 8.98325H0.328125V5.95268H22.8544V8.98325H22.8533ZM0.328125 11.7296V25.8224L11.5913 19.5283L22.8544
      25.8224V11.7296H0.328125ZM22.8544 0.175781H0.328125V3.20636H22.8544V0.175781Z"
    />
  </svg>
);
